import { render, staticRenderFns } from "./WorkspaceItem.vue?vue&type=template&id=79760195&scoped=true&"
import script from "./WorkspaceItem.vue?vue&type=script&lang=js&"
export * from "./WorkspaceItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceItem.vue?vue&type=style&index=0&id=79760195&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79760195",
  null
  
)

export default component.exports